"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsMounted = exports.useEffectOnce = exports.useDocumentEvent = exports.useDelayedEffectOnce = void 0;

var _react = require("react");

var _time = require("./time");

const useDocumentEvent = (type, listener, options) => {
  const eventPairRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (eventPairRef.current) {
      document.removeEventListener(eventPairRef.current.type, eventPairRef.current.listener);
    }

    eventPairRef.current = {
      type,
      listener
    };
    document.addEventListener(type, listener, options);
    return () => {
      if (eventPairRef.current) {
        document.removeEventListener(eventPairRef.current.type, eventPairRef.current.listener);
        eventPairRef.current = null;
      }
    };
  }, [type, listener]);
};

exports.useDocumentEvent = useDocumentEvent;

const useEffectOnce = callback => {
  const hasTriggeredCallback = (0, _react.useRef)(false);
  (0, _react.useEffect)(() => {
    if (!hasTriggeredCallback.current) {
      hasTriggeredCallback.current = true;
      callback();
    }
  }, [callback]);
};

exports.useEffectOnce = useEffectOnce;

const useDelayedEffectOnce = (delay, callback) => {
  const hasTriggeredCallback = (0, _react.useRef)(false);
  const mountedTime = (0, _react.useRef)(0);
  (0, _react.useEffect)(() => {
    if (hasTriggeredCallback.current) {
      return;
    }

    if (!mountedTime.current) {
      mountedTime.current = _time.TIME.now();
    }

    const diff = mountedTime.current + delay - _time.TIME.now();

    if (diff > 0) {
      let timerId = setTimeout(() => {
        if (!hasTriggeredCallback.current) {
          hasTriggeredCallback.current = true;
          timerId = null;
          callback();
        }
      }, diff);
      return () => {
        if (timerId) {
          clearTimeout(timerId);
          timerId = null;
        }
      };
    } else if (!hasTriggeredCallback.current) {
      hasTriggeredCallback.current = true;
      callback();
    }
  }, [delay, callback]);
};

exports.useDelayedEffectOnce = useDelayedEffectOnce;

const useIsMounted = () => {
  const isMounted = (0, _react.useRef)(false);
  (0, _react.useEffect)(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  return (0, _react.useCallback)(() => isMounted.current, []);
};

exports.useIsMounted = useIsMounted;